import type { CollaboratorPermission } from '@/types/auth'

type PermissionChecker = (permission: CollaboratorPermission) => boolean

export function canViewCampaignDashboard(
  isCollaborator: boolean,
  hasPermission: PermissionChecker
): boolean {
  if (!isCollaborator) return true
  return hasPermission('metrics.view')
}

export function canListInstitutionCampaigns(
  isCollaborator: boolean,
  hasPermission: PermissionChecker
): boolean {
  if (!isCollaborator) return true
  return hasPermission('campaigns.view') || hasPermission('metrics.view')
}
